import { useTranslation } from 'react-i18next';
import type { KnownProblem } from './api';

/** The save's failure, in words: the title and the sentence for the problem that came back. */
export function SaveErrorNotice({
  error,
}: {
  readonly error: KnownProblem | 'OTHER' | 'documentFailed';
}) {
  const { t } = useTranslation('expenses');
  return (
    <div role="alert" className="rounded-lg border border-destructive/40 p-3 text-sm">
      <p className="font-semibold text-destructive">{t('capture.save.failedTitle')}</p>
      <p>
        {error === 'documentFailed'
          ? t('capture.save.documentFailed')
          : t(`capture.save.problems.${error}`)}
      </p>
    </div>
  );
}
